module.exports = __webpack_public_path__ + "img/1dd4ecd3082f41f6981dec31310003b4.svg";